<template>
	<a
		v-if="credit.profilePath"
		:href="credit?.profilePath"
		@click="clicked({ searchString: credit.name, personId: credit.personId })"
	>
		<span class="title-credit-name">{{ credit?.name }}</span>
	</a>

	<span
		v-else
		class="title-credit-name"
		@click.prevent="clicked({ searchString: credit.name, personId: credit.personId })"
		>{{ credit.name }}</span
	>
</template>

<script setup lang="ts">
import type { CreditFragment } from '@/pages/graphql/fragments/TitleDetails.fragment';

import { SnowplowPersonContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { CollectionType } from '@/enums/collection-type';

import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useUserStore } from '@/stores/pinia/useUserStore';

const props = defineProps<{
	credit: CreditFragment;
}>();

const router = useRouter();

const userStore = useUserStore();
const filterStore = useFilterStore();

function clicked({ searchString, personId }: { searchString?: string; personId?: number }) {
	TrackingHelper.trackEvent(
		'persons_credit_name',
		{
			action: 'clicked',
			label: props.credit?.role,
			property: `${personId}`,
		},
		// credit prop sets a non-null default value but TS isn't catching it (Vue 2)
		[new SnowplowPersonContext(personId!, searchString!)]
	);

	if (!props.credit?.profilePath) {
		userStore.saveSearchTerm(searchString);
		const newRoute = filterStore.updateRouterState({
			collectionType: CollectionType.SEARCH,
			routeQuery: { q: searchString, person_id: personId },
		});

		if (newRoute) router.push(newRoute);
	}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';

.title-credit-name {
	cursor: pointer;
	color: $jw-color-lightblue;

	&:hover {
		color: $jw-color-lightgray;
	}
}
</style>
